import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

import * as styles from './PageTitle.css';

interface IPageTitleProps {
  text: string;
}

export const PageTitle: React.VFC<IPageTitleProps> = ({ text }) => (
  <div className={styles['container']}>
    <ArticleHeading1 as="h1">{text}</ArticleHeading1>
  </div>
);
